module.exports = __webpack_public_path__ + "img/403.9c1dbf48.svg";